<template>
  <BaseCaptcha :is-authenticated="isAuthenticated">
    <NuxtLayout>
      <VitePwaManifest />
      <NuxtPage />
    </NuxtLayout>
  </BaseCaptcha>
  <BaseNotificationsProvider />
  <AuthPopupProvider />
  <QuickNavButton />
</template>

<script setup lang="ts">
import { useAuth } from '~/entities/auth'
import { QuickNavButton } from '~/features/quick-nav-button'
import { useTheme } from '~/shared/lib'
import { BaseCaptcha, BaseNotificationsProvider } from '~/shared/ui'
import { AuthPopupProvider } from '~/widgets/auth-popup'

const { isDark } = useTheme()
const { isAuthenticated } = useAuth()

useHead({
  htmlAttrs: {
    class: isDark.value ? 'dark' : '',
  },
})
</script>
